export default "/assets/images/problem-solved-06.992aab0b3d218e5a.webp";